"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../const");

var _helpers = require("../../helpers");

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _useStyles = require("../../hooks/useStyles");

var _contentUi = _interopRequireDefault(require("../content/content-ui"));

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _featureCard = require("./feature-card.styled");

var _style = _interopRequireDefault(require("./style"));

var _types = require("../../types");

var _video = require("../video");

var _video2 = require("../video/video");

var _const2 = require("./const");

var _lazyLoadImage = require("../lazy-load-image");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FeatureCard = function FeatureCard(_ref) {
  var id = _ref.id,
      mediaItems = _ref.mediaItems,
      overline = _ref.overline,
      headline = _ref.headline,
      bodyText = _ref.bodyText,
      _ref$layoutType = _ref.layoutType,
      layoutType = _ref$layoutType === void 0 ? _const2.FeatureCardLayout.INLINE : _ref$layoutType,
      _ref$layoutArrangemen = _ref.layoutArrangement,
      layoutArrangement = _ref$layoutArrangemen === void 0 ? _const2.FeatureCardLayoutArrangement.IMG_LEFT : _ref$layoutArrangemen,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? _const.TextAlignment.LEFT : _ref$textAlign,
      removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      _ref$theme = _ref.theme,
      currentTheme = _ref$theme === void 0 ? _const2.FeatureCardTheme.WHITE : _ref$theme,
      _ref$cardBackground = _ref.cardBackground,
      cardBackground = _ref$cardBackground === void 0 ? 'transparent' : _ref$cardBackground;
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      type = _themeStrategy$curren.type,
      overlineColor = _themeStrategy$curren.headline1Color,
      mainColor = _themeStrategy$curren.headline2Color;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isOffset = layoutType === _const2.FeatureCardLayout.OFFSET;
  var isBackgroundOn = cardBackground !== 'transparent';
  var mainButtonColor = (0, _helpers.getButtonColorByTheme)(isDarkTheme);
  var styles = (0, _useStyles.useStyles)('a', _style.default);
  var theme = {
    $textAlign: textAlign,
    $theme: currentTheme,
    $layoutType: layoutType,
    $layoutArrangement: layoutArrangement,
    $styles: styles
  };
  var _invertedColorStrateg = _const.invertedColorStrategy[cardBackground],
      accentColor = _invertedColorStrateg.accentColor,
      defaultColor = _invertedColorStrateg.defaultColor,
      buttonColor = _invertedColorStrateg.buttonColor;
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_featureCard.Container, {
    removeTopPadding: removeTopPadding,
    removeBottomPadding: removeBottomPadding,
    isOffsetLayout: isOffset,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_FEATURE_CARD,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_featureCard.RowStyled, null, /*#__PURE__*/_react.default.createElement(_featureCard.ColStyled, {
    xl: 6,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_featureCard.Content, {
    bg: cardBackground
  }, !!overline && /*#__PURE__*/_react.default.createElement(_featureCard.Headline1, {
    color: isBackgroundOn ? accentColor : overlineColor
  }, overline), !!headline && /*#__PURE__*/_react.default.createElement(_featureCard.Headline2, {
    color: isBackgroundOn ? defaultColor : mainColor
  }, headline), !!bodyText && /*#__PURE__*/_react.default.createElement(_featureCard.CardText, null, /*#__PURE__*/_react.default.createElement(_contentUi.default, {
    measure: "sm",
    color: isBackgroundOn ? defaultColor : mainColor
  }, bodyText)), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    color: isBackgroundOn ? buttonColor : mainButtonColor,
    buttons: buttons,
    alignCenter: false,
    mt: 30
  }))), /*#__PURE__*/_react.default.createElement(_featureCard.ColStyled, {
    xl: 6,
    xs: 12,
    order: "first"
  }, /*#__PURE__*/_react.default.createElement(Media, {
    items: mediaItems
  })))));
};

var Media = function Media(_ref2) {
  var _items$reduce;

  var _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);
  var isDesktop = !isMobile && !isTablet;
  var noImage = items.find(function (_ref3) {
    var mimeType = _ref3.mimeType;
    return !mimeType;
  });
  if (noImage) return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
    align: "center",
    as: "h2",
    fontWeight: "bold",
    measure: "h1"
  }, "Please publish all images");
  var data = items.reduce(function (res, _ref4) {
    var fileReference = _ref4.fileReference,
        visible = _ref4.visible,
        mimeType = _ref4.mimeType,
        title = _ref4.title,
        altText = _ref4.altText,
        thumbnail = _ref4.videoAssetPreviewImage;
    res[visible] = {
      src: fileReference,
      isVideo: mimeType.indexOf(_types.MediaTypes.VIDEO) !== -1,
      title: title,
      altText: altText,
      thumbnail: thumbnail
    };
    return res;
  }, (_items$reduce = {}, _defineProperty(_items$reduce, _types.DevicesTypes.DESKTOP, null), _defineProperty(_items$reduce, _types.DevicesTypes.TABLET, null), _defineProperty(_items$reduce, _types.DevicesTypes.MOB, null), _items$reduce));
  var desktopData = data[_types.DevicesTypes.DESKTOP];
  var tabletData = data[_types.DevicesTypes.TABLET] || desktopData;
  var mobileData = data[_types.DevicesTypes.MOB] || tabletData;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDesktop && /*#__PURE__*/_react.default.createElement(MediaItem, {
    data: desktopData
  }), isTablet && /*#__PURE__*/_react.default.createElement(MediaItem, {
    data: tabletData
  }), isMobile && /*#__PURE__*/_react.default.createElement(MediaItem, {
    data: mobileData
  }));
};

var VideoModal = function VideoModal(_ref5) {
  var _ref5$src = _ref5.src,
      src = _ref5$src === void 0 ? '' : _ref5$src,
      _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? '' : _ref5$title,
      _ref5$isOpened = _ref5.isOpened,
      isOpened = _ref5$isOpened === void 0 ? false : _ref5$isOpened,
      _ref5$onClose = _ref5.onClose,
      onClose = _ref5$onClose === void 0 ? null : _ref5$onClose,
      _ref5$thumbnail = _ref5.thumbnail,
      thumbnail = _ref5$thumbnail === void 0 ? null : _ref5$thumbnail;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPlaying = _useState2[0],
      setIsPlaying = _useState2[1];

  var handleVideoPlayed = function handleVideoPlayed() {
    return setIsPlaying(true);
  };

  var handleVideoPaused = function handleVideoPaused() {
    if (isPlaying) setIsPlaying(false);
  };

  return /*#__PURE__*/_react.default.createElement(_featureCard.ModalStyled, {
    isOpen: isOpened,
    onClose: onClose,
    measure: "lg"
  }, /*#__PURE__*/_react.default.createElement(_featureCard.ModalHeaderStyled, null, title), /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    p: [isMobile ? 0 : 30],
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_featureCard.VideoWrapperStyled, {
    onClick: handleVideoPaused
  }, /*#__PURE__*/_react.default.createElement(_video.Video, {
    muted: true,
    volume: 0,
    config: {
      file: {
        attributes: {
          preload: 'metadata',
          muted: false,
          volume: 1
        },
        forceVideo: true
      }
    },
    src: src,
    playsinline: true,
    playIcon: /*#__PURE__*/_react.default.createElement("span", null),
    playing: isPlaying,
    preview: thumbnail,
    onPlay: handleVideoPlayed,
    onPause: handleVideoPaused,
    cover: true
  }), /*#__PURE__*/_react.default.createElement(_video2.PlayButtonComponent, {
    isPlaying: isPlaying,
    centered: true,
    onClick: handleVideoPlayed
  }), /*#__PURE__*/_react.default.createElement(_video2.PauseButtonComponent, {
    isPlaying: isPlaying
  }))));
};

var MediaItem = function MediaItem(_ref6) {
  var data = _ref6.data;

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isModalShown = _useState4[0],
      setIsModalShown = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isPlaying = _useState6[0],
      setIsPlaying = _useState6[1];

  var handlePopupClosed = function handlePopupClosed() {
    return setIsModalShown(false);
  };

  var handlePopupOpened = function handlePopupOpened() {
    return setIsModalShown(true);
  };

  var handleVideoPlayed = function handleVideoPlayed() {
    return setIsPlaying(true);
  };

  return data && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, data.isVideo ? /*#__PURE__*/_react.default.createElement(_featureCard.VideoWrapperMobStyled, null, /*#__PURE__*/_react.default.createElement(_video.Video, {
    muted: true,
    volume: 0,
    config: {
      file: {
        attributes: {
          preload: 'metadata',
          muted: true,
          volume: 0
        },
        forceVideo: true
      }
    },
    src: data.src,
    playsinline: true,
    playIcon: /*#__PURE__*/_react.default.createElement("span", null),
    playing: isPlaying,
    preview: data.thumbnail,
    onPlay: handleVideoPlayed,
    cover: true
  }), /*#__PURE__*/_react.default.createElement(_video2.PlayButtonComponent, {
    isPlaying: isPlaying,
    centered: true,
    onClick: handlePopupOpened
  }), /*#__PURE__*/_react.default.createElement(VideoModal, {
    src: data.src,
    title: data.title,
    isOpened: isModalShown,
    onClose: handlePopupClosed,
    thumbnail: data.thumbnail
  })) : /*#__PURE__*/_react.default.createElement(_reactIntersectionObserver.InView, {
    triggerOnce: true
  }, function (_ref7) {
    var inView = _ref7.inView,
        ref = _ref7.ref;
    return inView ? /*#__PURE__*/_react.default.createElement(_featureCard.ImageWrap, null, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: data.src,
      placeholderSrc: data.src,
      alt: data.altText,
      fit: "cover"
    })) : /*#__PURE__*/_react.default.createElement("div", {
      ref: ref
    });
  }));
};

var _default = FeatureCard;
exports.default = _default;